export const WebRequestConsoleNavigation = {
    WebRequestConsolePage: '/admin/web-request-console'
};
